//
// Type guards for convenience
//

export const isString = (value: unknown): value is string =>
  typeof value === 'string'

export const isFunction = (value: unknown): value is Function =>
  typeof value === 'function'

export const isNil = (value: unknown): value is null | undefined =>
  value == null

export const isObject = (value: unknown): value is object =>
  value != null && typeof value === 'object'

export const isWithTopic = <T extends object | Function>(
  value: T
): value is T & { topic: string } => 'topic' in value && isString(value.topic)

//
// Path utility functions
//

const NORMALIZE_RE = /^\/+|\/+$/g

export const normalize = (path: string): string =>
  path.replace(NORMALIZE_RE, '')

export const split = (path?: string | null): [string, string] => {
  let child = ''
  let rest = ''

  if (path) {
    const cleanPath = normalize(path)
    if (cleanPath) {
      const idx = cleanPath.indexOf('/')
      if (idx === -1) {
        child = cleanPath
      } else {
        child = normalize(cleanPath.slice(0, idx))
        rest = normalize(cleanPath.slice(idx + 1))
      }
    }
  }

  return [child, rest]
}
